import React, { useEffect, useState } from "react";
import {Button,Card, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Grid,Chip} from '@mui/material';
import moment from "moment";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';


function EmployeeTrainingList(props) {
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        props.modal();
        setOpen(false);
        }
    useEffect(()=>{
        if(props.open){
            setOpen(true)
        }
    },[props])
    console.log(props)
    
    const formatDate = (date) => {
        return moment(date).format('MMM-DD-YYYY');
    }


    return (
        <div>
            <Dialog
            fullWidth="md"
            maxWidth="md"
                open={open}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                <Typography id="modal-modal-title" className='modal-heading' variant="h6" component="h2">{props.empName} - {props.data && props.data.length>0? props.data[0].statusName:""} Training</Typography>
                </DialogTitle>
                <DialogContent dividers>
                   {props.data.length>0?
                   props.data.map((list)=>{
                    return(
                        <Card sx={{padding:1,margin:1}}>
                            <Grid container>
                                <Grid item xs={10}>
                               <h1 className="training-title">  {list.title}</h1>
                                
                   <p className="training-date" > <CalendarTodayIcon className="myicon" /> {formatDate(list.startDate)} to {formatDate(list.endDate)}</p>
                               {list.comments?<p><span className="training-date">Trainer Comments:</span>{list.comments}</p>:""}
                                </Grid>
                                {/* <Grid item xs={2} >
                               <Chip label={list.statusName} className="btn-compt"/>
                                </Grid> */}
                            </Grid>
                    
                    
                   </Card>
                    )
                   }):
                   "Fetching data..."}
                </DialogContent>
                <DialogActions>
                    <Button  className="theme-btn cancel-btn" onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EmployeeTrainingList